import {
    SET_LIST_COURSE_REVIEW_DATA,
  SET_LIST_COURSE_REVIEW_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listCourseReviewData: null,
  listCourseReviewDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_COURSE_REVIEW_DATA:
      return {
        ...state,
        loading: false,
        listCourseReviewData: action.listCourseReviewData,
      };

    case SET_LIST_COURSE_REVIEW_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listCourseReviewDataTotal: action.listCourseReviewDataTotal,
      };

    default:
      return { ...state };
  }
};
